export function ProgressBar({
  value,
  label,
  color,
}: {
  value: number;
  label?: string;
  color?: string;
}) {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div>
      {label !== undefined && (
        <div className="mb-1 flex items-center justify-between text-xs text-slate-600">
          <span>{label}</span>
          <span>{clamped}%</span>
        </div>
      )}
      <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200">
        <div
          className="h-full transition-all"
          style={{ width: `${clamped}%`, backgroundColor: color ?? 'var(--brand-accent)' }}
        />
      </div>
    </div>
  );
}
